import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import CopyIcon from './CopyIcon';
import CopyLinkIcon from './CopyLinkIcon';
import { getTrackingUrl } from './trackingUrl';

// Matches the admin panel's AwbLink styling exactly, so an AWB reads as clickable the
// same way in both panels — spread after the caller's own sx so link color/underline
// always wins over each table's base text color.
const LINK_SX = {
  color: '#1d4ed8',
  textDecoration: 'none',
  borderBottom: '1px dashed #93c5fd',
  pb: '1px',
  width: 'fit-content',
  '&:hover': { color: '#1e40af', borderBottomStyle: 'solid' },
};

export default function AwbLinkCell({ awb, sx, extraQuery = '', fallback = null, showTrackingLink = false }) {
  if (!awb) return fallback !== null ? <Typography sx={sx}>{fallback}</Typography> : null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
      <Link to={`/order-detail?waybill=${awb}${extraQuery}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <Typography sx={{ ...sx, ...LINK_SX }}>{awb}</Typography>
      </Link>
      <CopyIcon text={awb} />
      {/* Opt-in: shareable public buyer tracking link (proship.in tracking app). Enabled on
          forward order listings; off by default so NDR/NPR/weight/etc. tables stay uncluttered. */}
      {showTrackingLink && <CopyLinkIcon url={getTrackingUrl(awb)} title="Copy tracking link (share with buyer)" />}
    </Box>
  );
}
